<template>
    <div
      class="modal"
      :id="idModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myExtraLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-confirmar-reiniciar">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fas fa-redo mr-2"></i> REINICIAR CONVERSA
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Fechar"
            @click="dismiss()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mt-2 p-4">
          <p>Ao reiniciar a conversa com o Assistente Online, toda sua conversa prévia será apagada, voltando ao menu de opções de atendimento. Tem certeza que deseja reiniciar a conversa?</p>
          <div class="text-center mt-5">
            <button class="btn-cards-modal" style="width: 380px;height: 36px;" type="button" @click="reniciarBot(true)">Reiniciar</button>
          </div>
        </div>
      </div>
    </div>
  </template>
    
  <script>
    
  export default {
      props: {
      idModal: String,
      tituloModal: String
    },
    setup(props, { emit }) {
      function dismiss() {
        emit("dismiss");
      }
  
      function reniciarBot(reset) {
        emit("reiniciar",reset);
      }
      return { dismiss, reniciarBot };
    }
  };
  </script>
    
  <style>
  
  .modal-confirmar-reiniciar {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 555px;
    height: 290px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 10px;
    opacity: 1;
    font-family: 'Raleway';
  }
  
  </style>
  